import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { requestPushPermission, messaging, onMessage } from "@/firebase";
import api from "@/lib/api";
import { toast } from "sonner";

export default function PushNotifications() {
    const { user } = useAuth();

    useEffect(() => {
        if (!user || user === false) return;

        // Request permission and register token
        const register = async () => {
            const token = await requestPushPermission();
            if (token) {
                await api.post("/push/register", { token }).catch(() => {});
            }
        };

        register();

        // Handle foreground messages
        const unsubscribe = onMessage(messaging, (payload) => {
            const { title, body } = payload.notification || {};
            if (title) {
                toast(title, {
                    description: body,
                    duration: 6000,
                });
            }
        });

        return () => unsubscribe();
    }, [user]);

    return null;
}